import { motion } from "framer-motion";
import { SectionLabel, FadeUp, EASE } from "@/components/Reveal";

const line1 = "From strategy to spotlight, we make brands shine.".split(" ");

const Philosophy = () => (
  <section data-testid="philosophy-section" className="relative z-10 -mt-8 w-full px-6 sm:-mt-10">
    <div className="card-soft rounded-[32px] py-10 sm:py-16 lg:py-20 text-center overflow-hidden relative flex flex-col justify-center min-h-[420px] sm:min-h-[550px] lg:min-h-[750px] xl:min-h-[910px]">
      <div
        className="absolute inset-0 pointer-events-none opacity-60"
        style={{ background: "radial-gradient(60% 55% at 50% 0%, rgba(214,200,223,0.35) 0%, transparent 70%)" }}
      />
      <div className="relative site-container">
        <SectionLabel data-testid="philosophy-label">Our Philosophy</SectionLabel>

        <h2 className="mt-6 sm:mt-10 lg:mt-[90px] max-w-full text-3xl sm:text-4xl lg:text-[44px] leading-snug tracking-tight">
          <span className="block font-normal">
            {line1.map((w, i) => (
              <motion.span
                key={i}
                className="inline-block mr-[0.28em]"
                initial={{ opacity: 0.14, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5, delay: i * 0.06, ease: EASE }}
              >
                {w}
              </motion.span>
            ))}
          </span>
          <motion.span
            className="block mt-3 font-normal"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.55, ease: EASE }}
          >
            With clear ideas and{" "}
            <span className="relative inline-block px-3 py-0.5 rounded-lg text-[#8C5EBA] font-medium" style={{ background: "rgba(140,94,186,0.12)" }}>
              creative that converts.
            </span>
          </motion.span>
        </h2>
      </div>
    </div>
  </section>
);

export default Philosophy;
